module.exports = __webpack_public_path__ + "static/media/04-fitguide.56ae3ccb.png";